<template>
  <v-dialog v-model="open" max-width="400">
    <div class="dialog-box">
      <h3>Add to Playlist</h3>
      <p class="track-name" v-if="track">{{ track.title || track.name }}</p>

      <div class="playlist-list" v-if="playlistsStore.playlists.length">
        <div
          v-for="playlist in playlistsStore.playlists"
          :key="playlist.id"
          class="playlist-row"
          @click="addTo(playlist)"
        >
          <v-icon color="#fff" size="20">mdi-playlist-music</v-icon>
          <span>{{ playlist.name }}</span>
          <span class="song-count">{{ playlist.song_count }} songs</span>
        </div>
      </div>
      <p v-else class="empty-message">You don't have any playlists yet.</p>

      <div class="create-row">
        <input
          type="text"
          placeholder="New playlist name"
          v-model="newPlaylistName"
          @keyup.enter="createAndAdd"
        />
        <button @click="createAndAdd" :disabled="!newPlaylistName.trim()">Create</button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/eventBus';
import { usePlaylistsStore } from '../stores/playlists';

export default {
  name: 'AddToPlaylistDialog',
  setup() {
    const playlistsStore = usePlaylistsStore();
    return { playlistsStore };
  },
  data() {
    return {
      open: false,
      track: null,
      newPlaylistName: '',
    };
  },
  mounted() {
    EventBus.on('open_add_to_playlist', (track) => {
      this.track = track;
      this.newPlaylistName = '';
      this.open = true;
      this.playlistsStore.ensureLoaded();
    });
  },
  methods: {
    async addTo(playlist) {
      const videoId = this.track?.videoId || this.track?.id;
      if (!videoId) return;
      const ok = await this.playlistsStore.addSongToPlaylist(playlist.id, videoId);
      if (ok) this.open = false;
    },
    async createAndAdd() {
      const name = this.newPlaylistName.trim();
      if (!name) return;
      const playlist = await this.playlistsStore.createPlaylist(name);
      if (!playlist) return;
      await this.addTo({ ...playlist, id: playlist.id });
    },
  },
};
</script>

<style scoped>
.dialog-box {
  background: #181818;
  color: white;
  padding: 24px;
  border-radius: 8px;
}

h3 {
  margin-bottom: 4px;
}

.track-name {
  color: #b3b3b3;
  font-size: 13px;
  margin-bottom: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.playlist-list {
  max-height: 240px;
  overflow-y: auto;
  margin-bottom: 16px;
}

.playlist-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.playlist-row:hover {
  background: #ffffff14;
}

.playlist-row span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.song-count {
  margin-left: auto;
  color: #888;
  font-size: 12px;
  flex-shrink: 0;
}

.empty-message {
  color: #888;
  font-size: 14px;
  margin-bottom: 16px;
}

.create-row {
  display: flex;
  gap: 8px;
}

.create-row input {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 4px;
  background: #333;
  color: white;
}

.create-row input:focus {
  outline: 2px solid #e50914;
}

.create-row button {
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background: #e50914;
  color: white;
  font-weight: 600;
  cursor: pointer;
}

.create-row button:disabled {
  background: #7a0a0f;
  cursor: not-allowed;
}

@media (max-width: 675px) {
  .dialog-box {
    padding: 16px;
  }
}
</style>
